document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {
        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;
    });

    let cardsSwiper = document.querySelectorAll(".cards__container-slider");
    if(cardsSwiper){
        cardsSwiper.forEach((item)=>{
            new Swiper(".cards__container-slider#"+item.id,{
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: ".cards__container-slider-pagination#"+item.id,
                    clickable: true,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 3,
                        spaceBetween: 25,
                        pagination: false,
                    },
                },
            })
        });
    }

    let sliderSwiper = document.querySelectorAll(".slider__container-slider");
    if(sliderSwiper){
        sliderSwiper.forEach((item)=>{
            let images = item.querySelectorAll('figure');
            let boolRewind = true;
            let boolLoop = false;
            if(images.length > 3){
                boolRewind = false;
                boolLoop = true;
            }
            new Swiper(".slider__container-slider#"+item.id,{
                loop: true,
                slidesPerView: 1,
                spaceBetween: 15,
                pagination: {
                    el: ".slider-pagination#"+item.id,
                    type: "fraction",
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' +
                            ' / ' +
                            images.length;
                    }
                },
                navigation: {
                    nextEl: ".slider-arrow-next#"+item.id,
                    prevEl: ".slider-arrow-prev#"+item.id,
                },
                breakpoints: {
                    640: {
                        rewind: boolRewind,
                        loop: boolLoop,
                        slidesPerView: 2.5,
                    },
                },
            })
        });
    }

    let reviewSwiper = document.querySelectorAll(".reviews__slider");
    if(reviewSwiper){
        reviewSwiper.forEach((item)=>{
            new Swiper(".reviews__slider",{
                loop: true,
                pagination: {
                    el: ".reviews-pagination",
                    type: "fraction",
                },
                navigation: {
                    nextEl: ".reviews-arrow-next",
                    prevEl: ".reviews-arrow-prev",
                },
            })
        });
    }

    let sliderImageSwiper = document.querySelectorAll(".slider-image__bottom-right-slider");
    if(sliderImageSwiper){
        sliderImageSwiper.forEach((item)=>{
            new Swiper(".slider-image__bottom-right-slider#"+item.id,{
                loop: true,
                slidesPerView: 1.1,
                spaceBetween: 20,
                pagination: {
                    el: ".slider-image-pagination#"+item.id,
                    type: "fraction",
                },
                navigation: {
                    nextEl: ".slider-image-arrow-next#"+item.id,
                    prevEl: ".slider-image-arrow-prev#"+item.id,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 2.8,
                        spaceBetween: 10,
                    },
                },
            })
        });
    }

    let sliderSuitesImage = document.querySelectorAll(".suites__container-each-images");
	if(sliderSuitesImage){
		sliderSuitesImage.forEach((item)=>{
			new Swiper(".suites__container-each-images#"+item.id,{
				loop: true,
				pagination: {
					el: ".suites-pagination#"+item.id,
					type: "fraction",
				},
				navigation: {
					nextEl: ".suites-arrow-next#"+item.id,
					prevEl: ".suites-arrow-prev#"+item.id,
				},
			})
		});
	}

    let sliderV2Image = document.querySelectorAll(".slider-v2__right-image");
	if(sliderV2Image){
		sliderV2Image.forEach((item)=>{
            let images = item.querySelectorAll('figure');
            let boolRewind = true;
            let boolLoop = false;
            if(images.length > 2){
                boolRewind = false;
                boolLoop = true;
            }
			new Swiper(".slider-v2__right-image#"+item.id,{
                loop: true,
                slidesPerView: 1,
                spaceBetween: 25,
                allowTouchMove: false,
				navigation: {
					nextEl: ".slider-v2-arrow-next#"+item.id,
					prevEl: ".slider-v2-arrow-prev#"+item.id,
				},
                breakpoints: {
                    640: {
                        rewind: boolRewind,
                        loop: boolLoop,
                        slidesPerView: 1.5,
                    },
                },
			})
		});
	}

    let sliderV2Copy = document.querySelectorAll(".slider-v2__left-text");
	if(sliderV2Copy){
		sliderV2Copy.forEach((item)=>{
			new Swiper(".slider-v2__left-text#"+item.id,{
                autoHeight: false,
				loop: true,
                effect: "fade",
                slidersPerView: 1,
                allowTouchMove: false,
                fadeEffect: { crossFade: true },
				pagination: {
					el: ".slider-v2-pagination#"+item.id,
					type: "fraction",
				},
				navigation: {
					nextEl: ".slider-v2-arrow-next#"+item.id,
					prevEl: ".slider-v2-arrow-prev#"+item.id,
				},
                breakpoints: {
                    640: {
                        autoHeight: true,
                    },
                },
			})
		});
	}

    let gallerySlider = document.querySelectorAll(".gallery__slider");
	if(gallerySlider){
		gallerySlider.forEach((item)=>{
			new Swiper(".gallery__slider#"+item.id,{
				loop: true,
                slidesPerView: 1.1,
                spaceBetween: 20,
				pagination: {
					el: ".gallery-pagination#"+item.id,
					type: "fraction",
				},
				navigation: {
					nextEl: ".gallery-arrow-next#"+item.id,
					prevEl: ".gallery-arrow-prev#"+item.id,
				},
			})
		});
	}

    let sliderV3Swiper = document.querySelectorAll(".slider-v3__container-slider");
    if(sliderV3Swiper){
        sliderV3Swiper.forEach((item)=>{
            let images = item.querySelectorAll('figure');
            let boolRewind = true;
            let boolLoop = false;
            if(images.length > 3){
                boolRewind = false;
                boolLoop = true;
            }
            new Swiper(".slider-v3__container-slider#"+item.id,{
                loop: true,
                slidesPerView: 1,
                spaceBetween: 15,
                pagination: {
                    el: ".slider-v3-pagination#"+item.id,
                    type: "fraction",
                },
                navigation: {
                    nextEl: ".slider-v3-arrow-next#"+item.id,
                    prevEl: ".slider-v3-arrow-prev#"+item.id,
                },
                breakpoints: {
                    640: {
                        rewind: boolRewind,
                        loop: boolLoop,
                        slidesPerView: 3,
                    },
                },
            })
        });
    }
});